"use strict";

function productFAQ() {
  var el = document.querySelectorAll(".c-product-faq__item");
  if (!el) {
    return;
  }
  Array.from(el).forEach(function (accordion) {
    var title = accordion.querySelector(".c-product-faq__item__title");
    title.addEventListener('click', function (e) {
      if (e.currentTarget.parentNode.classList.contains('c-product-faq__item--open')) {
        e.currentTarget.parentNode.classList.remove('c-product-faq__item--open');
      } else {
        Array.from(el).forEach(function (item) {
          item.classList.remove("c-product-faq__item--open");
        });
        e.currentTarget.parentNode.classList.add('c-product-faq__item--open');
      }
    });
  });
}
productFAQ();